import { render, staticRenderFns } from "./EmployeeData.vue?vue&type=template&id=237d69a6"
import script from "./EmployeeData.vue?vue&type=script&lang=js"
export * from "./EmployeeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports